import {useNav} from "@/hooks/useNav";
import {r} from "@/utils/responsive";
import {motion} from "motion/react";
import React, {useState} from "react";
import TextType from "./TextType";
import K8SKeeperCard from "@/components/cards/K8sKeeperCard";
import ChaosMonsterCard from "@/components/cards/ChaosMonsterCard";
import MasterBotCard from "@/components/cards/MasterBotCard";
import YAMLOracleCard from "@/components/cards/YAMLOracleCard";
import ButtonSpan from "@/components/ButtonSpan";
import buttonMainStartGlow from "@/assets/img/button_main_glow_start.png"
import ButtonMain from "@/components/ButtonMain";
import ShortcutReforge from "@/components/ShortcutReforge";
import {useShortcuts} from "@/hooks/useShortcuts";

interface IntroUniverseProps extends React.HTMLAttributes<HTMLDivElement> {
}

const IntroUniverse: React.FC<IntroUniverseProps> = ({
                                                         className,
                                                         ...props
                                                     }) => {
    const [isTyping, setIsTyping] = useState<boolean>(true);
    const {navigateToSection, isTransitioning, currentSection} = useNav();
    const shouldHide = isTransitioning && currentSection === "intro_universe";

    useShortcuts({
        onEnter: () => navigateToSection('briefing'),
        enabledSections: ['intro_universe']
    });

    return (
        <div
            {...props}
            style={{
                position: "absolute",
                inset: 0,
                zIndex: 5,
                overflow: "scroll",
            }}
        >
            <motion.div
                // animate={{opacity: shouldHide ? 0 : 1}}
                transition={{duration: 0.4, ease: "easeOut"}}
                style={{
                    padding: `${r.vmax(195)} ${r.vmax(496)} ${r.vmax(195)} ${r.vmax(490)}`,
                    display: "flex",
                    flexDirection: "column",
                    gap: r.vmax(0),
                }}
            >
                <motion.div
                    style={{position: "relative"}}
                    initial={{y: 20, opacity: 0}}
                    animate={{y: 0, opacity: 1}}
                    transition={{duration: 0.6, ease: "easeOut"}}
                >
                    <TextType
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            whiteSpace: "pre-wrap",
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: r.vmax(64),
                            lineHeight: r.vmax(72),
                            letterSpacing: r.vmax(-0.40),
                        }}
                        text={[
                            `Вас ждут союзники, загадки, \nиспытания — и сила, способная \nвернуть порядок в этот мир.`,
                        ]}
                        onAnimationComplete={() => setIsTyping(false)}
                    />
                    <p
                        style={{
                            whiteSpace: "pre-wrap",
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: r.vmax(64),
                            lineHeight: r.vmax(74),
                            opacity: 0,
                            pointerEvents: "none",
                            userSelect: "none",
                            marginBottom: r.vmax(-7),
                        }}
                    >
                        {`Вас ждут союзники, загадки, \nиспытания — и сила, способная \nвернуть порядок в этот мир.`}
                    </p>
                </motion.div>
                {(
                    <>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            whileInView={{y: 0, opacity: 1}}
                            viewport={{once: true, margin: "-100px"}}
                            transition={{duration: 0.6, ease: "easeOut"}}
                        >
                            <K8SKeeperCard/>
                        </motion.div>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            whileInView={{y: 0, opacity: 1}}
                            viewport={{once: true, margin: "-100px"}}
                            transition={{duration: 0.6, delay: 0.1, ease: "easeOut"}}
                            style={{
                                paddingTop: r.vmax(2),
                            }}
                        >
                            <ChaosMonsterCard/>
                        </motion.div>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            whileInView={{y: 0, opacity: 1}}
                            viewport={{once: true, margin: "-100px"}}
                            transition={{duration: 0.6, delay: 0.2, ease: "easeOut"}}
                        >
                            <MasterBotCard/>
                        </motion.div>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            whileInView={{y: 0, opacity: 1}}
                            viewport={{once: true, margin: "-100px"}}
                            transition={{duration: 0.6, delay: 0.3, ease: "easeOut"}}
                        >
                            <YAMLOracleCard/>
                        </motion.div>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            whileInView={{y: 0, opacity: 1}}
                            viewport={{once: true, margin: "-100px"}}
                            transition={{duration: 0.6, delay: 0.4, ease: "easeOut"}}
                            style={{
                                marginTop: r.vmax(70),
                                height: r.vmax(180),
                                width: "100%",
                                position: 'relative',
                            }}
                        >
                            <div style={{
                                position: "absolute",
                                top: 0,
                                left: '50%',
                                transform: "translateX(-50%)",
                            }}>
                                <ButtonMain width={1218} height={180} glowWidth={1298} glowHeight={260} glowTop={-30}
                                            glowImage={buttonMainStartGlow}
                                            onClick={() => navigateToSection('briefing')}>
                                    <ButtonSpan>kubectl, begin!</ButtonSpan>
                                    <ShortcutReforge isLarge>ENTER</ShortcutReforge>
                                </ButtonMain>
                            </div>
                        </motion.div>
                    </>
                )}
            </motion.div>
        </div>
    );
};

export default IntroUniverse;
